// Fiyat Değişim Logları raporu kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.priceChangeLogs';

export const priceChangeLogsGuide = (t: TFunction): GuideContent => ({
  layout: 'report',
  title: t(`${G}.title`, 'Fiyat Değişim Logları nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu ekran, ürün fiyatlarında yapılan değişiklikleri tarih sırasıyla izleyebilmeniz için hazırlanmıştır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    actions: t(`${G}.regions.actions`, 'Excel ve tablo ayarı'),
    filters: t(`${G}.regions.filters`, 'Arama ve filtreler'),
    table: t(`${G}.regions.table`, 'Değişim listesi'),
    totals: t(`${G}.regions.totals`, 'Toplam satırı'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Hangi kayıtlara bakıyorsunuz?'),
      text: t(`${G}.s1.text`, 'Ekran ⋮ menüsünden açıldığında tüm ürünlerin fiyat değişikliklerini gösterir. Tek bir ürün için açıldıysa ürün adı başlığın altında görünür ve yalnız o ürünün kayıtları listelenir. "Geri" ile önceki ekrana dönersiniz.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Kayıtları daraltın'),
      text: t(`${G}.s2.text`, 'Arama kutusunda ürün adı, stok kodu veya kullanıcı arayın. Filtre düğmesi Fiyat Türü, Başlangıç ve Bitiş Tarihi alanlarını açar; böylece sadece ihtiyacınız olan kayıtları listelersiniz.'),
      tips: [
        t(`${G}.s2.tip1`, '"Filtreleri Temizle" tüm arama ve filtreleri tek seferde sıfırlar.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Satırları okuyun'),
      text: t(`${G}.s3.text`, 'Her satırda eski ve yeni fiyatı, değişim yönünü ve yüzdesini aynı anda görürsünüz. Fiyat artışı olan satırlar yeşil, düşüş olanlar kırmızı tonla işaretlenir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kullanıcı ve Kaynak sütunları, değişikliğin kim tarafından ve nereden (stok yönetimi, şube fiyatları, toplu güncelleme, alış faturası, Excel içe aktarma vb.) yapıldığını gösterir.'),
        t(`${G}.s3.tip2`, 'Sütun başlığına tıklayarak sıralayabilirsiniz.'),
      ],
    },
    {
      region: 'totals',
      title: t(`${G}.s4.title`, '4. Toplam satırı'),
      text: t(`${G}.s4.text`, 'Tablonun altındaki satır, yalnız görünen sayfayı değil filtrenin tamamını özetler: toplam değişiklik sayısı, zam ve indirim adetleri ile ortalama değişim yüzdesi.'),
    },
    {
      region: 'actions',
      title: t(`${G}.s5.title`, '5. Dışa aktarın, tabloyu düzenleyin'),
      text: t(`${G}.s5.text`, '"Excel İndir" mevcut filtre sonucunu dışa aktarır. "Tabloyu Özelleştir" ile hangi sütunların görüneceğini seçersiniz; Para Birimi ve Notlar sütunları başta gizlidir. Yenile düğmesi listeyi tazeler.'),
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Sayfalar arasında gezin'),
      text: t(`${G}.s6.text`, 'Kayıtlar sayfalar halinde gelir; sayfa başına 25, 50 veya 100 satır seçebilirsiniz. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
